import store from '@/store'
export default [
  {
    path: '/users',
    name: 'user',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "user" */ '@/pages/User/index-v2.vue')
  },
  {
    path: '/users/create',
    name: 'user-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/User/create.vue')
  },
  {
    path: '/users/:id',
    name: 'user-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/User/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('user/find', to.params.id)
      next()
    }
  }
]
